export enum GenderType {
    male = 'male',
    female = 'female',
    other = 'other',
    unknown = '',
}
